import { useEffect, useState } from "react";
import {
  getProductsFromCachedBasketCookie,
  ProductsInBasket,
} from "@~/utils/product.ts";

const BASKET_QTY_UPDATED_EVENT = "jl-events.browser.basketQuantityUpdated";

export function useCachedBasketData(): ProductsInBasket {
  const [cachedBasketData, setCachedBasketData] = useState<ProductsInBasket>(
    [],
  );

  const updateCachedBasketData = () => {
    setCachedBasketData(getProductsFromCachedBasketCookie());
  };

  useEffect(function subscribeToBasketQuantityUpdates() {
    updateCachedBasketData();
    window.addEventListener(BASKET_QTY_UPDATED_EVENT, updateCachedBasketData);

    return function unsubscribeFromBasketQuantityUpdates() {
      window.removeEventListener(
        BASKET_QTY_UPDATED_EVENT,
        updateCachedBasketData,
      );
    };
  }, []);

  return cachedBasketData;
}
